module.exports = __webpack_public_path__ + "img/bgjiantou.181f84bc.png";